export default __webpack_public_path__ + "static/media/Ruby.11264e30.png";